import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, TimeoutError} from 'rxjs';
import {retryBackoff} from 'backoff-rxjs';
import {timeout} from 'rxjs/operators';

export class HttpErrorInterceptor implements HttpInterceptor {
  private readonly retryInterval = 35000;
  private readonly interceptHttpStatuses = [500, 503];

  private static isHttpError(error: any): boolean {
    return error instanceof HttpErrorResponse;
  }

  private static isTimeoutError(error: any): boolean {
    return error instanceof TimeoutError;
  }

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let retryInterval = this.retryInterval;
    if (request.method === 'POST' && request.url.includes('groups') && request.url.includes('tabs')) {
      retryInterval = 60000;
    }
    return next.handle(request)
      .pipe(
        timeout(retryInterval),
        retryBackoff({
            initialInterval: 1000,
            maxRetries: 3,
            shouldRetry: (error) => {
              if (HttpErrorInterceptor.isHttpError(error)) {
                return this.interceptHttpStatuses.includes(error.status);
              }
              return HttpErrorInterceptor.isTimeoutError(error);
            }
          }
        ));
  }
}
